import React from 'react';
export function GuaranteeSection() {
  return <section className="py-10 px-5 bg-negro-suave text-center" data-id="element-84">
      <div className="max-w-[650px] mx-auto bg-gradient-bonus border-2 border-teal rounded-2xl p-8 relative" data-id="element-85">
        <div className="w-20 h-20 bg-gradient-teal rounded-full flex items-center justify-center mx-auto mb-4 text-[36px] shadow-[0_0_30px_rgba(78,205,196,0.3)]" data-id="element-86">
          🛡️
        </div>
        <h2 className="font-playfair text-[clamp(22px,3vw,30px)] text-blanco mb-3" data-id="element-87">
          Garantía Total de 30 Días
        </h2>
        <p className="text-[15px] text-[#cccccc] leading-[1.7] mb-2" data-id="element-88">
          Te damos{' '}
          <strong className="text-teal" data-id="element-89">
            30 días completos para probarlo sin riesgo.
          </strong>{' '}
          Si no ves mejoras reales, te devolvemos el{' '}
          <strong className="text-teal" data-id="element-90">100% de tu dinero.</strong>
        </p>
        <p className="text-dorado font-bold text-[16px]" data-id="element-91">
          Sin formularios. Sin preguntas. Sin dramas.
        </p>
      </div>
    </section>;
}